module.exports = __webpack_public_path__ + "static/helga-butcher-article-3b09737f9e46bdae625e8c14efec2896.jpg";